import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

type FilterFnArg<T> = T extends Array<infer U> ? U : T;

export interface UseQueryWithFilterOptions<T> extends UseQueryOptions<T> {
    filterFn?: (data: FilterFnArg<T>) => boolean;
}

export const useQueryWithFilter = <T>(options: UseQueryWithFilterOptions<T>) => {
    const { filterFn, ...queryOptions } = options; 
    const queryResult = useQuery(queryOptions);
    let filteredData = queryResult.data;
    if (filterFn && queryResult.data) {
        filteredData = Array.isArray(queryResult.data)
            ? queryResult.data.filter(filterFn) as T
            : filterFn(queryResult.data as FilterFnArg<T>) ? queryResult.data : undefined;
    }
    return { ...queryResult, data: filteredData };
};
